import Constants from '../../Constants';
import { drawMultiLineString } from '../../drawingUtils';
import VirtualDomElement from '../VirtualDomElement';

export default class TextElement extends VirtualDomElement {
  constructor({ text, fontSize, x, y, color = '#000000', ellipsis = true }) {
    super();

    this.set('fontSize', fontSize);
    this.set('text', text);
    this.set('x', x);
    this.set('y', y);
    this.set('width', fontSize * text.length * 2); //vague approximation of text space (could optimize in the future)
    this.set('height', fontSize);
    this.set('ellipsis', ellipsis);
    this.set('color', color);
  }

  draw(ctx, transform) {
    ctx.beginPath();
    ctx.font = `${this.get('fontSize') * transform.k}px ${Constants.general.fontFamily}`;
    ctx.fillStyle = this.get('color');
    ctx.textAlign = 'left';
    const [x, y] = transform.apply([this.get('x'), this.get('y')]);

    drawMultiLineString(
      ctx,
      this.get('text'),
      x,
      y,
      this.get('width'),
      this.get('fontSize'),
      2,
      this.get('ellipsis'),
    );
  }
}
